import { PROMO_CODE_DATA } from '../homeConfig'

export function usePromoBannerText() {
  return PROMO_CODE_DATA
}
